import {
  layoutParagraph,
  resolveFont,
  resolveLineHeightPx,
  toPx,
} from "../text";

// Heading.js / SubHeading.js: each "\n" line is its own centered line box
// (an empty line still occupies one line). The whole fontStyle, including
// marginBottom, applies only when the text is non-empty.
const layoutTitle = (ctx, text, style, defaultSize) => {
  const { ops, measurer, left, width, top } = ctx;
  if (!text) return 0;
  const font = resolveFont(style, { size: defaultSize });
  const lineHeightPx = resolveLineHeightPx(font, style?.lineHeight);
  let y = top;
  String(text)
    .split("\n")
    .forEach((line) => {
      const height = layoutParagraph(ops, {
        measurer,
        font,
        text: line,
        left,
        width,
        top: y,
        align: "center",
        lineHeightPx,
        color: style?.color,
        decoration: style?.textDecoration,
      });
      y += height || lineHeightPx;
    });
  return y - top + toPx(style?.marginBottom, 0);
};

export const layoutHeading = (ctx) =>
  layoutTitle(ctx, ctx.options?.heading, ctx.fontStyle?.heading, 18);

export const layoutSubHeading = (ctx) =>
  layoutTitle(ctx, ctx.options?.subheading, ctx.fontStyle?.subHeading, 20);

/** Heading + subheading stack; returns the total height consumed. */
export const layoutTitles = (ctx) => {
  const headingHeight = layoutHeading(ctx);
  const subHeight = layoutSubHeading({ ...ctx, top: ctx.top + headingHeight });
  return headingHeight + subHeight;
};
